export const basicFormData = () => ({
  inputData: [
    {
      make_item_id: "",
      buy_item_id: "",
      qty_per_item: "",
      created_by: null,
      updated_by: null,
      is_active: true,
    },
  ],
});

export const createPageData = () => {
  const payload = {
    modelName: "item_masters",
    moduleWhereCondition: { is_active: true },
    relations: [
      {
        module: "bom_masters",
        moduleAs: "bomMakeItem",
        isModuleWhereConditionRequired: true,
        subModule: "item_masters",
        subModuleAs: "buyItem",
        subSubModule: "uom_masters",
        subSubModuleAs: "uom",
      },
      {
        module: "uom_masters",
        moduleAs: "uom",
      },
      {
        module: "category_masters",
        moduleAs: "category",
      },
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const navigatePage = { back: "/bom-list" };

  const headerName = "BOM";

  const validationType = "BOMCreate";
  const createEndpoint = "/createBom";
  const updateEndpoint = "/updateBom";
  const getEndpoint = "/getBomById";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "item_masters",
    replace_status: true,
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
    whereCondition: {
      id: {
        in: "%%bom_master_make_id%%",
      },
    },
  };

  const columnData = [
    { label: "sr.no", value: "index" },

    { label: "Make Item Code", value: "item_code" },

    { label: "description", value: "description" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/bom-create",
    edit: "/bom-create",
    view: "/bom-view",
  };

  const searchfields = [
    "item_code",
    "description",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "BOM";
  const endpoint = "/listBom";
  const exportFileName = "bomData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "item_masters",
  replace_status: true,
  relations: [
    {
      module: "user_masters",
      moduleAs: "createdBy",
    },
    {
      module: "user_masters",
      moduleAs: "updatedBy",
    },
  ],
  whereCondition: {
    id: {
      in: "%%bom_master_make_id%%",
    },
  },
  pagination: { page: 1, pageSize: 10000 },
};
